'use client';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, Suspense } from 'react';
import { usePostHog } from 'posthog-js/react';
import { posthogUTM, RPostHogThrottle } from './index';
import { getInviteInfo } from '@/ueshook/useInviteCode';

const { utm } = posthogUTM();
getInviteInfo();
function PostHogPageView() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const posthog = usePostHog();

  useEffect(() => {
    const cacheKey = 'kaze_pageview_cache_date';
    const currentDate = new Date().toISOString().split('T')[0]; // 获取当前日期
    const cachedData = localStorage.getItem(cacheKey);

    // 如果有缓存
    if (cachedData) {
      const { date } = JSON.parse(cachedData);
      if (date === currentDate) {
        return;
      } else {
        // 缓存日期不等则移除缓存，走下面的重置缓存和上报逻辑
        localStorage.removeItem(cacheKey);
      }
    }

    // 生成新的本地缓存
    const newCache = { date: currentDate, timestamp: Date.now() };
    localStorage.setItem(cacheKey, JSON.stringify(newCache));

    // 主动上报用户访问
    if (pathname && posthog) {
      let url = window.origin + pathname;
      if (searchParams && searchParams.toString()) {
        url = url + `?${searchParams.toString()}`;
      }
      RPostHogThrottle('user_visit_kaze', { url, ...utm });

      // 设置定时器，若用户在应用中待超过十秒，则上报另一个事件
      const timer = setTimeout(() => {
        RPostHogThrottle('user_visit_kaze_duration_10', { url, ...utm });
      }, 10000);

      // 清理定时器
      return () => clearTimeout(timer);
    }
  }, [pathname, posthog, searchParams]);

  /**
   * @description Why does the pageview component need a useEffect
   * https://posthog.com/docs/libraries/next-js#why-does-the-pageview-component-need-a-useeffect
   */
  useEffect(() => {
    if (pathname && posthog) {
      let url = window.origin + pathname;
      if (searchParams && searchParams.toString()) {
        url = url + `?${searchParams.toString()}`;
      }
      posthog.capture('$pageview', { $current_url: url });
    }
  }, [pathname, posthog, searchParams]);

  // 触发获取,不可移除
  // return <div className='hidden'>{JSON.stringify({ ...utm, ...invite })}</div>;
  return null;
}

const Loading = () => <div>Loading...</div>;
const PostHogPageViewSuspense = () => (
  <Suspense fallback={<Loading />}>
    <PostHogPageView />
  </Suspense>
);

export default PostHogPageViewSuspense;
